import { ERROR_CODE } from "@plugins/common/constant/error.constant";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      error: {
        code: "",
        message: "",
        subMessage: "",
      },
    };
  },
  computed: {
    hasError() {
      return this.error.message !== "";
    },
  },
  methods: {
    ...mapActions("app", ["addError"]),
    validateCommonErrorCode(response) {
      if (response.code !== "ok") {
        let needPassiveApiFailHandler = true;
        const errorCode = response.errorMap["0"];
        if (errorCode === ERROR_CODE.NOT_FOUND) {
          needPassiveApiFailHandler = false;
          this.$router.push({ name: "PageNotFound" });
        }
        if (errorCode === ERROR_CODE.ACCESS_DENIED) {
          needPassiveApiFailHandler = false;
          this.$router.push({ name: "Forbidden" });
        }
        if (needPassiveApiFailHandler) {
          this.passiveApiFailHandler();
        }
        return false;
      }
      return true;
    },
    actionApiFailHandler() {
      this.error.message = this.$i18n.t("api_action_generic_error_title");
      this.error.subMessage = this.$i18n.t("api_action_generic_error_subtitle");
      if (this.processingStore) {
        this.processingStore.reset(this.anchor);
      } else {
        this.isProcessing = false; //TO BE REMOVED ONCE EVERY1 USES processingStore
      }
    },
    passiveApiFailHandler(error) {
      const errorCode =
        error &&
        error.response &&
        error.response.status === 500 &&
        error.response.data.errorMap &&
        error.response.data.errorMap[0]
          ? error.response.data.errorMap[0]
          : "";
      const errorStatus =
        error && error.response && error.response.status ? error.response.status : null;

      //handled in http.config no need to show twice
      if (errorCode === ERROR_CODE.REQUEST_BLOCKED) {
        return;
      }
      this.addError({
        subTitle: errorCode,
        hasTimeout: errorCode ? false : true,
        id: errorCode ? errorCode : "generic",
        code: errorCode,
        statusCode: errorStatus,
      });
    },
    clearErrorState() {
      this.error.code = "";
      this.error.message = "";
      this.error.subMessage = "";
    },
    handleCloseError() {
      this.clearErrorState();
    },
  },
};
